<template>
  <div class="wrapper wrapper-content">
      <div class="col-md-6 pull-left qrLink">
          <div class="row padding-10">
              <div class="vertical-line"></div>
              <div class="col-md-12">
                  <h2 class="pull-left" style="font-weight: bolder;">
                      {{branchStats.branchName}}
                  </h2>
              </div>
          </div>
          <div class="row padding-10">
              <a id="text_color"
                 :href="qrCode"
              >
                  <i class="fa fa-link fa-lg"/>&emsp;
                  {{
                  qrCode.slice(0, 60)
                  }}
              </a>
          </div>
          <div class="row padding-10">
                <span id="text_color">
                <i class="fa fa-clock-o"/>
                &emsp;
                {{(branchStats.modified)
                    ? $moment.parseZone(branchStats.modified).local().format('DD/MM/YYYY hh:mm:ss A')
                    : "Not initialized"}}
            </span>
          </div>

      </div>
      <div class="col-md-2 counts">
          <h3>Total Scans</h3>
          <h4>
              <b class="total_scans">
                  {{branchStats.totalScans}}
              </b> / <b class="unique_scans">
              {{branchStats.uniqueScans}} Unique
          </b>
          </h4>
          <button class="btn btn-danger counts detail_btn" type="button"
                  @mouseover="iconMoved = true"
                  @mouseout="iconMoved = false"
                  title="Show Details"
                  @click="showDetails"
                  data-toggle="collapse"
                  :data-target="'#collapse_'+id"
          >
              <i class="fa fa-angle-double-down" :class="iconMoved ? 'icon-moved' : ''"></i>&nbsp;&nbsp;
              <span class="bold">Details</span>
          </button>

      </div>
      <div class="col-md-2" :class="!(!branchStats.disabled && !branchStats.deleted) && 'padding-39'">
          <VueQrcode v-if="!branchStats.disabled && !branchStats.deleted"
                     id="MenuQRcode"
                     :value="qrCode"
                     :options="{ width: 180}">
          </VueQrcode>
          <img src="/img/qr/no-qr.jpeg" v-else alt="no qr" class="square-130">
      </div>
      <div class="col-md-2 ">
          <div class="row">
              <button v-if="!branchStats.deleted"
                      @click="downloadMenu"
                      title="Download QR code"
                      class="btn btn-default btn-warning margin-3 download_button">
                  <i class="fa fa-download"/>
                  Download
              </button>
              <button v-else
                      @click="updateQRCodeStatus(true)"
                      title="Initialize QR code"
                      @mouseover="iconRotated = true" @mouseout="iconRotated = false"
                      class="btn btn-default margin-5">
                  <i class="fa fa-gear" :class="iconRotated ? 'rotate-icon' : ''"/>
                  Initialize QR Code
              </button>
          </div>
          <div class="row action_buttons">
              <a v-if="!branchStats.deleted"
                 class="btn btn-white btn-bitbucket"
                 title="Delete QR"
                 @click="updateQRCodeStatus(true)"
              >
                  <i class="fa fa-trash"/>
              </a>
              <a v-if="!branchStats.deleted"
                 class="btn btn-white btn-bitbucket"
                 :title="!branchStats.disabled ? 'Disable QR' : 'Enable QR'"
                 @click="updateQRCodeStatus( false)"
              >
                  <i class="fa" :class="!branchStats.disabled ? 'fa-ban' : 'fa-check'"/>
              </a>
          </div>


      </div>
  </div>
</template>
<script>

import VueQrcode from "@chenfengyuan/vue-qrcode";
import {updateQRStatus} from "@/api/BranchQrDetailsApi";
import QRAnalyticsGraphs from "@/components/QrAnalytics/QRAnalyticsGraphs.vue";
import cryptoJs from "crypto-js";

export default {
    name: "QRAnalyticsCounts",
    components: {QRAnalyticsGraphs, VueQrcode},
  data() {
    return {
      detailBtnStyle: '',
      showGraphs: false,
      sauce: 'OkKYetiB4@dy',
      iconMoved: false,
      iconRotated: false

    }
  },
    props: {
        id: {
            type: Number,
            required: true,
        },
        branchStats: {
            type: Object,
            required: true,
            default: {
                "branchId": 0,
                "branchName": "",
                "disabled": false,
                "deleted": false,
                "totalScans": 0,
                "uniqueScans": 0,
                "created": "",
                "modified": "",
                "scansOverTimeStats": [],
                "scansByOperatingSystem": [],
                "scansByCountries": [],
                "scansByCities": []
            },
        }
    },
    computed: {
        qrCode() {
            return this.branchStats.deleted || this.branchStats.disabled ? "Not Initialized" : this.encryptNumber(this.branchStats.branchId);
        }
    },
    mounted() {
        $('#collapse_0').collapse('show');
    },
    methods: {
      showDetails() {
        this.$store.dispatch('updateCollapseValue', this.id);
        this.id !== 0 && $('#collapse_0').collapse('hide');
            $('.detail_btn').click(function () {
                var target = $(this).data('target');
                // Hide all other collapses
                $('.collapse').not(target).collapse('hide');
                // Show the selected collapse
                $(target).collapse('show');
            });
        },
        encryptNumber(number) {
            const encryptedValue = cryptoJs.AES.encrypt(number + '', this.sauce).toString().replaceAll('+', 'xMl3Jk').replaceAll('/', 'Por21Ld').replaceAll('=', 'Ml32');
            return "https://menu.bayked.co/" + encryptedValue;
        },
        getLink: function () {
            return (this.branchStats.deleted || this.branchStats.disabled) ? "Not Initialized" : this.branchStats.qrCode;
        },
        downloadMenu: function () {
            const canvas = document.getElementById("MenuQRcode");
            const pngUrl = canvas
                .toDataURL("image/png")
                .replace("image/png", "image/octet-stream");

            let downloadLink = document.createElement("a");
            downloadLink.href = pngUrl;
            downloadLink.download = this.branchStats.branchName.replaceAll(" ", "-") + ".png";
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        },
        updateQRCodeStatus: async function (isDeleted = false) {
            let deleteItemResp = true;
            if (isDeleted && !this.branchStats.deleted) {
                let deleteItem = await this.confirmFromUserBeforeDeleting("Are You Sure You Want To Delete this QR code?");
                deleteItemResp = deleteItem.value;
            }
            if (deleteItemResp) {
                this.showLoading()
                let updateQRCodeStatusResp = await updateQRStatus(
                    this.branchStats.branchId, isDeleted
                ).catch((error) => {
                    this.showErrorMessage(error)
                });

                if (updateQRCodeStatusResp.data.status === 200) {
                    Swal.close();
                    this.$emit('updateBranchQRCodeStatus', this.branchStats.branchId, isDeleted)
                } else {
                    this.showErrorMessage(updateQRCodeStatusResp.data.message);
                }
            }
        },
      moveIcon() {
        this.iconMoved = true;
      },
      resetIcon() {
        this.iconMoved = false;
      }
    }
}
</script>

<style scoped>
.total_scans{
    font-size: 35px;
    font-weight: 700;
    color: #1ab394;
}
.unique_scans {
    font-weight: 600;
    color: grey;
}
.counts{
    margin-top: 10px;
}
.qrLink{;
    margin-top: 15px;
    font: inherit;
}
#text_color{
    color: #898888 !important;
    font-size: 16px;
}
.btn-default{
    margin-top: 15px;
    width: 250px;
    height: 50px;
}
.action_buttons{
    width: 75%;
    margin-left: 25%;
}
.btn-white{
    margin-left: 15px;
}
.wrapper-content{
    padding-top: 2px;
}
.detail_btn {
  max-height: 34px;
}
.square-130 {
  height: 134px;
  width: 134px;
}
.padding-10 {
    padding-left: 40px;
    padding-right: 30px;
    padding-bottom: 20px;
}
.row > div:nth-child(4).vertical-center {
  display: flex;
  align-items: center;
}
.margin-3 {
  margin-top: 3rem;
}
.margin-5 {
  margin-top: 5rem;
}
.vertical-line {
  border-left: 2px solid #EEF0F1;
  height: 100%;
  position: absolute;
  top: 0;
  left: 95%;
}
.download_button{
  margin-bottom: 10px;
  width: 90%;
}
</style>